<template lang="pug">
v-layout.ma-0.pa-0.the-loading(
  justify-center,
  align-content-center,
  v-if="loading"
)
  v-flex(xs6, align-self-center)
    v-progress-linear(indeterminate height="8" rounded)
    slot
</template>

<script>
export default {
  name: 'TheLoading',
  props: {
    loading: { type: Boolean, default: true },
  },
};
</script>

<style lang="scss" scoped>
.the-loading {
  position: absolute;
  // background-color: ;
  height: calc(100vh - 80px);
  top: 0;
  width: 100%;
  right: 0;
  z-index: 3;
}
</style>
